__turbopack_context__.v({
  "BookmarkDesktop": "_05R2VW_BookmarkDesktop",
  "BookmarkMobile": "_05R2VW_BookmarkMobile",
  "Button": "_05R2VW_Button",
  "ButtonMain": "_05R2VW_ButtonMain",
  "Content": "_05R2VW_Content",
  "Content--Map": "_05R2VW_Content--Map",
  "Header": "_05R2VW_Header",
  "Main": "_05R2VW_Main",
  "Root": "_05R2VW_Root",
  "SectionHeader": "_05R2VW_SectionHeader",
  "SectionTitle": "_05R2VW_SectionTitle",
  "SectionTitle--MatchSectionInset": "_05R2VW_SectionTitle--MatchSectionInset",
  "SectionTitle--WithPadding": "_05R2VW_SectionTitle--WithPadding",
  "Summary": "_05R2VW_Summary",
  "TabArea": "_05R2VW_TabArea",
  "Text": "_05R2VW_Text",
  "TopSection": "_05R2VW_TopSection",
  "TopSection--WithButton": "_05R2VW_TopSection--WithButton",
  "TopSectionHeader": "_05R2VW_TopSectionHeader",
  "skeleton-loading": "_05R2VW_skeleton-loading",
});
